import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { toast } from 'react-toastify';

import Loading from '../../../components/global/loading/Loading';
import OrderCard from '../../../components/global/orderCard/OrderCard';
import { useOrder } from '../../../context/OrderContext';
import { Order as OrderModel } from '../../../models/Order';
import Order from '../../odrer/Order';

function Orders() {
  const { getOrders } = useOrder();
  const [orders, setOrders] = React.useState<OrderModel[] | null>(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const orders = await getOrders();
        setOrders(orders);
      } catch (error: any) {
        toast.error(error.message);
      }
    };

    fetchOrders();
  }, [getOrders]);

  if (!orders) {
    return <Loading />;
  }

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <h1 className="font-semibold text-2xl mb-10">Twoje zamówienia</h1>
              {orders.length === 0 && (
                <p className="text-gray-500 text-sm">Brak zamówień</p>
              )}
              <div className="flex flex-col space-y-2">
                {orders.map((order) => (
                  <OrderCard key={order.id} order={order} />
                ))}
              </div>
            </div>
          }
        />
        <Route path="/:id/*" element={<Order />} />
      </Routes>
    </div>
  );
}

export default Orders;
